(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'prop-types', 'invariant', './ValidatorsContext', './FormContext', './utilities'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('invariant'), require('./ValidatorsContext'), require('./FormContext'), require('./utilities'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.invariant, global.ValidatorsContext, global.FormContext, global.utilities);
    global.Form = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _invariant, _ValidatorsContext, _FormContext, _utilities) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _invariant2 = _interopRequireDefault(_invariant);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var propTypes = {
    onChange: _propTypes.func,
    onReset: _propTypes.func,
    onSubmit: _propTypes.func,
    onUpdate: _propTypes.func
  };

  var Form = function (_Component) {
    _inherits(Form, _Component);

    function Form() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Form);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Form, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            children = _props.children,
            onSubmit = _props.onSubmit,
            onUpdate = _props.onUpdate,
            rest = _objectWithoutProperties(_props, ['children', 'onSubmit', 'onUpdate']);

        var formContext = _extends({}, this.getContext(), {
          register: this.registerSubComponent,
          unregister: this.unregisterSubComponent
        });

        return _react2.default.createElement('form', _extends({}, rest, {
          noValidate: true,
          onChange: this.onChange,
          onSubmit: this.onSubmit,
          onReset: this.onReset
        }), _react2.default.createElement(_FormContext.FormProvider, {
          value: formContext
        }, children));
      }
    }]);

    return Form;
  }(_react.Component);

  Form.defaultProps = {
    onChange: function onChange(e) {},
    onReset: function onReset() {},
    onSubmit: function onSubmit(c) {},
    onUpdate: function onUpdate(c) {}
  };
  Form.propTypes = _extends({}, propTypes, {
    // ValidatorsContext
    validators: (0, _propTypes.shape)({}).isRequired
  });

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.state = {
      config: {},
      dirty: {},
      errors: {},
      fields: {},
      submitted: false
    };
    this.initialValues = {};
    this.transforms = {};

    this.getContext = function () {
      var _state = _this2.state,
          dirty = _state.dirty,
          errors = _state.errors,
          fields = _state.fields,
          submitted = _state.submitted;
      return {
        dirty: dirty,
        errors: errors,
        fields: fields,
        isValid: Object.values(errors).every(function (error) {
          return error === null;
        }),
        resetAll: _this2.onReset,
        setError: _this2.setError,
        setField: _this2.setField,
        submit: _this2.onSubmit,
        submitted: submitted
      };
    };

    this.onChange = function (e) {
      _this2.props.onChange(e);

      var _e$target = e.target,
          checked = _e$target.checked,
          name = _e$target.name,
          type = _e$target.type,
          value = _e$target.value;

      if (e.defaultPrevented || !_this2.state.config[name]) {
        return;
      }

      var val = type === 'checkbox' ? checked : value;

      if (typeof _this2.transforms[name] === 'function') {
        val = _this2.transforms[name](val);
      }

      _this2.setField(_defineProperty({}, name, val));
    };

    this.onReset = function (e) {
      if (e) {
        e.preventDefault();
      }

      var _state2 = _this2.state,
          dirty = _state2.dirty,
          errors = _state2.errors,
          fields = _state2.fields;

      _this2.setStateInternal({
        dirty: Object.keys(dirty).reduce(function (allDirty, field) {
          return _extends({}, allDirty, _defineProperty({}, field, false));
        }, {}),
        errors: Object.keys(errors).reduce(function (allErrors, field) {
          return _extends({}, allErrors, _defineProperty({}, field, null));
        }, {}),
        fields: Object.keys(fields).reduce(function (allFields, field) {
          return _extends({}, allFields, _defineProperty({}, field, _this2.initialValues[field]));
        }, {}),
        submitted: false
      }, _this2.props.onReset);
    };

    this.onSubmit = function (e) {
      if (e) {
        e.preventDefault();
      }

      _this2.setStateInternal({
        submitted: true
      }, function () {
        _this2.props.onSubmit(_this2.getContext());
      });
    };

    this.setError = function (diff) {
      _this2.setStateInternal({
        errors: _extends({}, _this2.state.errors, diff)
      });
    };

    this.setField = function (diff) {
      var _state3 = _this2.state,
          config = _state3.config,
          dirty = _state3.dirty,
          fields = _state3.fields;

      var allFields = _extends({}, fields, diff);

      var areDirty = _extends({}, dirty, Object.keys(diff).reduce(function (allDirty, field) {
        return _extends({}, allDirty, _defineProperty({}, field, dirty[field] || diff[field] !== _this2.initialValues[field]));
      }, {}));

      _this2.setStateInternal({
        dirty: areDirty,
        errors: _this2.validate(config, allFields, areDirty),
        fields: allFields
      });
    };

    this.setStateInternal = function (updater) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      _this2.setState(updater, function () {
        callback.apply(undefined, arguments);

        _this2.props.onUpdate(_this2.getContext());
      });
    };

    this.validate = function (allConfig, allFields, areDirty) {
      return Object.entries(allConfig).reduce(function (allErrors, _ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            fieldName = _ref3[0],
            fieldValidators = _ref3[1];

        return _extends({}, allErrors, _defineProperty({}, fieldName, _this2.validateField(fieldName, fieldValidators, allFields, allErrors, areDirty)));
      }, {});
    };

    this.validateField = function (fieldName, fieldValidators, allFields, allErrors, areDirty) {
      var validators = _this2.props.validators; // if field is optional and the value doesn't pass the isRequired validator, skip all validators

      if (!fieldValidators.isRequired && validators.isRequired({})(allFields[fieldName]) !== null) {
        return null;
      }

      return Object.entries(fieldValidators).reduce(function (error, _ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            validatorName = _ref5[0],
            validatorConfig = _ref5[1];

        if (error) {
          return error;
        }

        var validator = validators[validatorName];
        (0, _invariant2.default)(validator, "You specified a validator that doesn't exist. You " + ('specified ' + validatorName + '. Available validators: \n\n') + Object.keys(validators).join(',\n'));
        var context = {
          fields: allFields,
          errors: _extends({}, _this2.state.errors, allErrors),
          isDirty: areDirty[fieldName]
        };

        if (typeof validatorConfig === 'function') {
          validatorConfig = validatorConfig(context);
        }

        if (typeof validatorConfig === 'string') {
          validatorConfig = {
            message: validatorConfig
          };
        }

        if (typeof validatorConfig.validateIf === 'function' && !validatorConfig.validateIf(context) || typeof validatorConfig.validateIf === 'boolean' && !validatorConfig.validateIf) {
          return null;
        }

        return validator(validatorConfig, context)(allFields[fieldName]);
      }, null);
    };

    this.registerSubComponent = function (subComponentConfig, transforms, initialValues) {
      _this2.initialValues = _extends({}, _this2.initialValues, initialValues);
      _this2.transforms = _extends({}, _this2.transforms, transforms);

      _this2.setStateInternal(function (prevState) {
        var config = _extends({}, prevState.config, subComponentConfig);

        var dirty = _extends({}, prevState.dirty, Object.keys(subComponentConfig).reduce(function (allDirty, field) {
          return _extends({}, allDirty, _defineProperty({}, field, false));
        }, {}));

        var fields = _extends({}, prevState.fields, initialValues);

        return {
          config: config,
          dirty: dirty,
          errors: _this2.validate(config, fields, dirty),
          fields: fields
        };
      });
    };

    this.unregisterSubComponent = function (subComponentConfig) {
      var keys = Object.keys(subComponentConfig);
      _this2.initialValues = (0, _utilities.removeFrom)(_this2.initialValues)(keys);
      _this2.transforms = (0, _utilities.removeFrom)(_this2.transforms)(keys);

      _this2.setStateInternal(function (prevState) {
        var config = (0, _utilities.removeFrom)(prevState.config)(keys);
        var dirty = (0, _utilities.removeFrom)(prevState.dirty)(keys);
        var fields = (0, _utilities.removeFrom)(prevState.fields)(keys);
        return {
          config: config,
          dirty: dirty,
          errors: _this2.validate(config, fields, dirty),
          fields: fields
        };
      });
    };
  };

  var FormWithValidatorsContext = (0, _ValidatorsContext.withValidators)(Form);
  FormWithValidatorsContext.propTypes = propTypes;
  exports.default = FormWithValidatorsContext;
});